<template>
    <div>
        <div class="loader" v-show="showLoading"></div>
        <div v-show="!showLoading">
            <div class="grid-wrapper">
                <kendo-datasource ref="datasource1"
                                  :transport="transportSettings"
                                  :filter="filter"
                                  :schema-model-id="'id'"
                                  :schema-model-fields="schemaModelFields"
                                  :schema-total="'total'"
                                  :schema-data="'data'"
                                  :page-size="gridOptions.pageable.size"
                                  :server-paging="true"
                                  :server-sorting="true"
                                  :server-filtering="true"
                                  :error="dataSourceError"
                                  :requestEnd="datasorceRequestEnd"></kendo-datasource>
                <kendo-grid ref="participantsGrid"
                            :data-source-ref="'datasource1'"
                            ::navigatable="gridOptions.navigatable"
                            :editable="gridOptions.editable"
                            :filterable="gridOptions.filterable"
                            :pageable="gridOptions.pageable"
                            :resizable="gridOptions.resizable"
                            :sortable-mode="gridOptions.sortable.mode"
                            :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                            :sortable-show-indexes="gridOptions.sortable.showIndexes"
                            :scrollable="gridOptions.scrollable"
                            :data-bound="dataBound">
                    <kendo-grid-column :field="'id'"
                                       :title="$t('id')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="true"
                                       :hidden="true">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'supplierId'"
                                       :title="$t('id')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="true"
                                       :hidden="true">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'name'"
                                       :title="$t('contract.name')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="true">
                    </kendo-grid-column>
                    <kendo-grid-column :template="btnsTemplate"
                                       field="btnsColumn"
                                       :width="150"
                                       :title="$t('actions')"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'number'"
                                       :title="$t('contract.number')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'subject'"
                                       :title="$t('contract.subject')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'active'"
                                       :title="$t('registers.organizers.gridHeaders.active')"
                                       :width="200"
                                       :template="isActive"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'validFromUtc'"
                                       :title="$t('contract.validFrom')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false"
                                       :format="'{0: dd-MM-yyyy HH:mm:ss}'">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'validToUtc'"
                                       :title="$t('contract.validTo')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false"
                                       :format="'{0: dd-MM-yyyy HH:mm:ss}'">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'conclusionDate'"
                                       :title="$t('contract.conclusionDate')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false"
                                       :format="'{0: dd-MM-yyyy HH:mm:ss}'">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'amount'"
                                       :title="$t('contract.amount')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                </kendo-grid>
            </div>
        </div>
    </div>
</template>
<script src="https://kendo.cdn.telerik.com/2019.2.619/js/pako_deflate.min.js"></script>

<script>
    import {Culture} from '../../../models/enums';
    import BtnsTemplate from '../../../components/grid/StandardBtnsTemplate';
    import Vue from "vue";

    export default {
        name: 'contracts-list-grid',
        components: {},
        props: {
            size: {
                default: 6,
                type: Number
            },
            componentName: {
                default: 'ContractsListGrid',
                type: String
            },
            lecturerId: {
                type: Number,
                default: null
            }
        },
        data() {
            return {
                settingsTooltipText: this.$t('buttons.settings.tooltipText'),
                titleKey: 'registers.events.participants.title',
                searchQuery: '',
                showLoading: false,
                schemaModelFields: {
                    id: {
                        name: 'id',
                        type: 'number',
                        editable: false,
                        nullable: false,
                        visible: true
                    },
                    supplierId: {
                        name: 'supplierId',
                        type: 'number',
                        editable: false,
                        nullable: false,
                        visible: true
                    },
                    name: {
                        name: 'name',
                        type: 'string',
                        editable: false,
                        nullable: false,
                        visible: true
                    },
                    number: {
                        name: 'number',
                        type: 'string',
                        editable: false,
                        nullable: false,
                        visible: true
                    },
                    subject: {
                        name: 'subject',
                        type: 'string',
                        editable: false,
                        nullable: false,
                        visible: true
                    },
                    amount: {
                        name: 'amount',
                        type: 'string',
                        editable: false,
                        nullable: false,
                        visible: true
                    },
                    validFromUtc: {
                        name: 'validFromUtc',
                        type: 'date',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    validToUtc: {
                        name: 'validToUtc',
                        type: 'date',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    conclusionDate: {
                        name: 'conclusionDate',
                        type: 'date',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    active: {
                        name: 'active',
                        type: 'boolean',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                },
                gridOptions: {
                    ...this.$store.getters.gridOptions,
                },
                working: false,
            }
        },
        methods: {
            dataBound(ev) {
            },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                });
            },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return {models: kendo.stringify(options.models)}
                } else {
                    // ������ POST action �� �������� �� �������������� � ������ �� �������������
                    // options. ���� �� ������� ���������� �� take, skip , page � ������ � ������
                    // �������� �����������
                    return kendo.stringify(options);
                }
            },
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            datasorceRequestEnd(e) {
                if (e.type == "read" && e.response) {
                    // 	console.log(e.response[0]);
                    //alert(e.respondashboard-ctrlse[0].TaskID);
                }
            },
            isActive: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.active ? 'badge-success' : 'badge-secondary') + '">' + kendo.htmlEncode(dataItem.active ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            refresh() {
                const grid = this.$refs.participantsGrid.kendoWidget();
                if (grid) {
                    grid.dataSource.read();
                }
            },
            btnsTemplate: function (e) {
                return {
                    template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                    templateArgs: {
                        ...e,
                        parentComponent: this.$refs.grid,
                        btns: [
                            {
                                name: 'details',
                                text: '',
                                tooltip: this.$t('buttons.details.tooltipText'),
                                class: 'btn btn-info',
                                icon: 'fas fa-eye',
                                show: true,
                                clickHandler: this.goToDetails
                            }
                        ]
                    }
                };
            },
            goToDetails(args) {
                this.$router.push(`/registers/externalSupplier/${args.supplierId}/details`);
            },
        },
        mounted() {

        },
        computed:
            {
                token: function () {
                    return this.$store.getters.authToken;
                },
                filter() {
                    return {};
                },
                isEnVersion() {
                    return this.$store.getters.currentCulture === Culture.EN;
                },
                transportSettings() {
                    let urlSuffix = '';
                    if (this.lecturerId) {
                        urlSuffix = this.lecturerId;
                    }

                    return {
                        read: {
                            url: this.$store.getters.baseUrl + `/api/lectors/listLecturerContracts/` + urlSuffix,
                            dataType: 'json',
                            type: 'POST',
                            contentType: 'application/json',
                            beforeSend: this.beforeSend
                        },
                        parameterMap: this.parameterMap
                    }
                }
            }
    }
</script>


<style>
    /*
        Use the DejaVu Sans font for display and embedding in the PDF file.
        The standard PDF fonts have no support for Unicode characters.
    */
    .k-pdf-export .k-grid {
        font-family: 'DejaVu Sans', 'Arial', sans-serif;
    }

    .k-pdf-export .k-filterable .k-grid-filter {
        display: none;
    }

    .k-pdf-export .k-with-icon .k-header-column-menu {
        display: none;
    }

    .k-grid .k-grid-header .k-header .k-link {
        height: auto;
    }

    .k-grid .k-grid-header .k-header {
        white-space: normal;
    }

    .k-grid-edit,
    .k-grid-details,
    .k-grid-delete,
    .k-grid-pdf,
    .k-grid-excel {
        padding: 0;
        margin-bottom: 2px;
    }
</style>
